
export default function About() {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              About SERVI-SUP S.R.L.
            </h2>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              SERVI-SUP S.R.L. is a leading technology company based in Obera, Argentina, dedicated to developing innovative software solutions that enhance digital security and privacy for users worldwide.
            </p>
            <p className="text-lg text-gray-600 mb-6 leading-relaxed">
              Our flagship VPN application represents our commitment to providing cutting-edge technology that protects your online presence. We believe that everyone deserves the right to browse the internet freely and securely, without compromising their personal information or digital footprint.
            </p>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              With a focus on user privacy, performance, and reliability, we continuously innovate and improve our services to meet the evolving needs of our global user base. Our team of experienced developers and security experts work tirelessly to ensure that our VPN solution remains at the forefront of digital protection technology.
            </p>
            
            <div className="flex flex-wrap gap-6">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                  <i className="ri-shield-check-fill text-blue-600 text-2xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">100%</div>
                  <div className="text-sm text-gray-600">Secure</div>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
                  <i className="ri-global-fill text-purple-600 text-2xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">50+</div>
                  <div className="text-sm text-gray-600">Countries</div>
                </div>
              </div>
              
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                  <i className="ri-speed-fill text-green-600 text-2xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">99.9%</div>
                  <div className="text-sm text-gray-600">Uptime</div>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/9f1816414e12a6dbc99d37895e35b785.jpg"
              alt="SERVI-SUP Technology"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover object-top"
            />
            <div className="absolute -bottom-8 -left-8 w-64 h-64 bg-gradient-to-br from-blue-600 to-purple-600 rounded-2xl -z-10 opacity-20"></div>
            <div className="absolute -top-8 -right-8 w-48 h-48 bg-gradient-to-br from-purple-600 to-pink-600 rounded-2xl -z-10 opacity-20"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
